module.exports = __webpack_public_path__ + "static/media/gf.f689ce44.svg";